import { FC } from 'react';

import _ from '../../locale';
import { LocalizedFilter } from '../../utility/ai-chat-content';
import FilterChip, { FilterChipVariant } from './FilterChip';

const EMPTY_VALUES: string[] = [];

export interface FilterChipsProps {
    localizedFilters: LocalizedFilter[];
    dataCollectionName?: string;
    variant?: FilterChipVariant;
}

const FilterChips: FC<FilterChipsProps> = ({ localizedFilters, dataCollectionName, variant }) => (
    <>
        {dataCollectionName && (
            <FilterChip
                label={_('dex_chat_data_collection_chip_label')}
                firstValue={dataCollectionName}
                remainingValues={EMPTY_VALUES}
                moreLabel=""
                variant={variant}
            />
        )}
        {localizedFilters.map(({ key, label, firstValue, remainingValues }, index) => (
            <FilterChip
                key={key}
                label={label}
                firstValue={firstValue}
                remainingValues={remainingValues}
                moreLabel={_('dex_chat_more_count', { count: remainingValues.length })}
                animationDelay={(dataCollectionName ? index + 1 : index) * 30}
                variant={variant}
            />
        ))}
    </>
);

export default FilterChips;
